
import React, { useEffect } from 'react'
import { navigate } from 'gatsby'
import moment from 'moment';
import BellIcon from '../../../../../static/img/icons/bell-icon-white.svg'
import closeIcon from '../../../../../static/img/icons/close-icon.svg'
import './style.sass'
import { useDispatch, useSelector } from 'react-redux';
import { dismissPushNotification, markAsRead } from '../../../../state/actions/notification';
import { selectContract } from '../../../../state/actions/contract';
import NotificationService from '../../../../services/NotificationService';

const PushNotification = ({ item }) => {


  useEffect(() => {
    setTimeout(() => dismiss(item), 5000);
  }, [item]);

  const dispatch = useDispatch();

  const dismiss = (notification) => {
    dispatch(dismissPushNotification(notification));
  }
  const markAsReadStatus = (ids) => {
    dispatch(markAsRead(ids));
  }

  const selectedContractId = useSelector(({ contract }) => contract.selectedContractId)
  const handleNavigation = (notification, currentContractId) => {
    dismiss(notification);
    markAsReadStatus([notification.id]);
    switchContract(notification, currentContractId)
    NotificationService.handleNotification(notification);
  };

  const switchContract = (notification, currentContractId) => {
    if (currentContractId === notification.contractId)
      return;

    dispatch(selectContract(notification.contractId));
  }




  return (
    <div className="notification-popup-card" onClick={() => handleNavigation(item, selectedContractId)}>
      <div className="popup-container">
        <div className="header">
          <label> New Notification</label>
          <img src={closeIcon} alt='close' className="close" onClick={() => dismiss(item)} />

        </div>
        <div className="body">
          <div className="notification-item-left-col">
            <div className="icon-container">
              <img src={BellIcon} alt="bell-icon" />
            </div>
          </div>
          <div className="notification-item-right-col">
            <label className="notification-title">
              {item?.title || "New notification"}
            </label>
            <label className="notification-message">
              {item?.message}
            </label>
            <label className="notification-time">
              {moment(moment.utc(item?.createdDate)).fromNow()}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PushNotification;